import { CpsIndex, USER_INDEX_SETTINGS_KEY } from '@cs-cms/types';
import { StorageHelper } from '@cs-cms/utils';
import React from 'react';
import { CurrentUserContext } from '../contexts/CurrentUserContext';
import { useGetCurrentUser } from '../hooks/currentUser/useGetCurrentUser';

interface CurrentUserProviderProps {
  children?: React.ReactNode;
}

export const CurrentUserProvider: React.FC<CurrentUserProviderProps> = ({ children }) => {
  const { data: currentUser, isLoading } = useGetCurrentUser();
  const [selectedIndex, setSelectedIndex] = React.useState<CpsIndex>();

  React.useEffect(() => {
    if (!currentUser?.indexes?.length) {
      return;
    }

    const storedId = StorageHelper.get(USER_INDEX_SETTINGS_KEY);
    if (!storedId) {
      setSelectedIndex(currentUser.indexes[0]);
      return;
    }

    const foundIndex = currentUser.indexes.find(index => index.id === parseInt(storedId));

    setSelectedIndex(foundIndex ?? currentUser.indexes[0]);
  }, [currentUser]);

  const handleSetSelectedIndex = (index: CpsIndex) => {
    setSelectedIndex(index);
    StorageHelper.set(USER_INDEX_SETTINGS_KEY, index.id);
  };

  return (
    <CurrentUserContext.Provider
      value={{
        currentUser,
        isLoading,
        selectedIndex,
        setSelectedIndex: handleSetSelectedIndex
      }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
};
